import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";

import IntegrateIcon1 from "../Assets/img/integrate/mikrotik.png";
import IntegrateIcon2 from "../Assets/img/integrate/sslcommerze.png";
import IntegrateIcon3 from "../Assets/img/integrate/bkash.svg";
import IntegrateIcon4 from "../Assets/img/integrate/nagad.svg";
import IntegrateIcon5 from "../Assets/img/integrate/elitbuzz.png";
import IntegrateIcon6 from "../Assets/img/integrate/boomcast.svg";
import IntegrateIcon7 from "../Assets/img/integrate/alphanet.svg";
const Integration = () => {
  const IntegrationMain = [
    {
      id: "item1",
      img: IntegrateIcon1,
      title: "Mikrotik API",
    },
    {
      id: "item2",
      img: IntegrateIcon2,
      title: "Payment Gateway",
    },
    {
      id: "item3",
      img: IntegrateIcon3,
      title: "Mobile Financial Service",
    },
    {
      id: "item4",
      img: IntegrateIcon4,
      title: "Mobile Financial Service",
    },
    {
      id: "item5",
      img: IntegrateIcon5,
      title: "Bulk SMS Service",
    },
    {
      id: "item6",
      img: IntegrateIcon6,
      title: "Bulk SMS Service",
    },
    {
      id: "item7",
      img: IntegrateIcon7,
      title: "Bulk SMS Service",
    },
  ];
  return (
    <>
      <section className="integrate-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="section-title">
                <h3>Integration</h3>
                <p>
                  ISP Digital has successfully integrate few API's which can
                  boost your operations
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="integrate-slider">
                <Swiper
                  modules={[Autoplay, Navigation]}
                  spaceBetween={30}
                  slidesPerView={4}
                  navigation
                  //   onSlideChange={() => console.log("slide change")}
                  //   onSwiper={(swiper) => console.log(swiper)}

                  loop={true}
                  autoplay={true}
                  breakpoints={{
                    // when window width is >= 640px
                    320: {
                      width: 320,
                      slidesPerView: 1,
                    },
                    // when window width is >= 768px
                    768: {
                      width: 768,
                      slidesPerView: 3,
                    },
                  }}
                >
                  {IntegrationMain.map((SingleIntegration) => (
                    <SwiperSlide key={SingleIntegration.id}>
                      <div className="single-i-slider">
                        <div className="single-integrate">
                          <div className="img-panel">
                            <img src={SingleIntegration.img} alt="#" />
                            <p>{SingleIntegration.title}</p>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Integration;
